export enum PromoRibbonStyle {
  PLUM = 'plum',
  GREEN = 'green',
  LIGHT_GREEN = 'light-green',
  BLACK = 'black',
  RED = 'red',
  ORANGE = 'orange',
  NAVY_BLUE = 'navy-blue',
  GOLD_WITH_DARK_TEXT = 'gold with dark text',
  GOLD_WITH_WHITE_TEXT = 'gold with white text',
  HARBOUR_GREY_WITH_GOLD_TEXT = 'harbour grey with gold text',
  HARBOUR_GREY_WITH_WHITE_TEXT = 'harbour grey with white text',
}

export enum RecentlyViewedClubRibbonStyle {
  PLUM = 'plum',
  GREEN = 'green',
  DARK_GREY = 'dark grey',
  PALE_GREEN = 'pale green',
  PALE_ORANGE = 'pale orange',
  GREY = 'grey',
}
